<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3">Tell families why they should book you for this Adventure</h1>
      <NoteBox v-if="noteBoxMessage" header="Things to Consider" :body="noteBoxMessage" />
      <div class="mt-24 mb-36" style="height: 186px">
        <TextArea
          id="SitterPassion-textarea"
          ref="textAreaComponent"
          v-model="sitterPassion"
          labelName="Description"
          :characterCounter="true"
          :minCharacters="minCharacters"
          :maxCharacters="maxCharacters"
          propClasses="resize-none h-full"
          class="h-full"
          :status="validationType"
          @text-area-status="textAreaStatusHandler"
        />
      </div>
      <div>
        <button class="text-left link-secondary underline mt-16 mb-24 w-auto" @click.prevent="showExamples">See examples</button>
      </div>
      <StickyButton v-if="!showPopup" :value="isEdit ? 'Save' : 'Next'" type="submit" />
    </form>

    <Popup v-model="showPopup" popupHeader="Examples" popupSize="lg">
      <PassionExamples />
    </Popup>
  </div>
</template>

<script lang="ts">
// components
import TextArea from '../../../components/textarea/TextArea.vue';
import helperStatus from '../../../helpers/status';
import NoteBox from '../../../components/note_box/NoteBox.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';
import Popup from '../../../components/popup/Popup.vue';
import PassionExamples from '../create/examples/PassionExamples.vue';

export default {
  name: 'Passion',
  components: { TextArea, NoteBox, StickyButton, Popup, PassionExamples },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      sitterPassion: this.$store.getters['adventures/adventureDraft'].sitterPassion || '',
      validationType: helperStatus.Neutral,
      showPopup: false,
    };
  },
  computed: {
    minCharacters(): number {
      return 75;
    },
    maxCharacters(): number {
      return 500;
    },
    noteBoxMessage(): string {
      return this.adventureMetaData?.categories?.[0].passionExample || '';
    },
  },
  methods: {
    textAreaStatusHandler(validationType) {
      this.validationType = validationType;
    },
    submitForm() {
      if (this.validationType !== helperStatus.Valid) {
        // @ts-ignore
        this.$refs.textAreaComponent.checkValidation();
      } else {
        this.setSitterPassion();
      }
      return false;
    },
    showExamples() {
      this.showPopup = true;
    },
    async setSitterPassion() {
      await this.$store.dispatch('adventures/updateStore', { sitterPassion: this.sitterPassion.trim() });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/title',
      });
    },
  },
};
</script>
